import { DataSourceExecutionEvent, DataSourceValidationEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutMonitorRecoveryControl } from "./autogen/AutogenLayoutMonitorRecoveryControl";
import { EdiUtility } from "./EdiUtility";
import { Api, DateUtil } from "@mcleod/core";

export class MonitorRecoveryControl extends AutogenLayoutMonitorRecoveryControl {

    override onLoad() {
        const isLogisticsLicensed = EdiUtility.isLogisticsLicensed();
        this.checkboxTransactionSetsInboundActivityVerifyStatuses.visible = isLogisticsLicensed;
        this.checkboxTransactionSetsInboundActivityVerifyReplies.visible = isLogisticsLicensed;
        this.checkboxTransactionSetsInboundActivityVerifyInvoices.visible = isLogisticsLicensed;
        this.checkboxTransactionSetsOutboundActivityVerifyLoadTenders.visible = isLogisticsLicensed;
        this.tabLogistics.visible = isLogisticsLicensed;
        this.setLastTimeRun();
    }


    textboxOccurrenceAfterDropDownSelection() {
        switch(this.textboxOccurrence.selectedItem?.displayValue) {
            case("Week"):
                this.textboxDayOfWeek.visible = true;
                this.textboxDayOfMonth.visible = false;
                this.textboxTimeOfDay.visible = true;
                break;
            case("Month"):
                this.textboxDayOfWeek.visible = false;
                this.textboxDayOfMonth.visible = true;
                this.textboxTimeOfDay.visible = true;
                break;
            case("Day"):
                this.textboxDayOfWeek.visible = false;
                this.textboxDayOfMonth.visible = false;
                this.textboxTimeOfDay.visible = true;
                break;
            default:
                this.textboxDayOfWeek.visible = false;
                this.textboxDayOfMonth.visible = false;
                this.textboxTimeOfDay.visible = false;
                break;
        }
        
    }

    sourceEdiMonitorControlAfterExecution(event: DataSourceExecutionEvent) {
       const occurrence =  this.mainDataSource.activeRow?.get("occurrence", null);
            switch(occurrence) {
            case("W"):
                this.textboxDayOfWeek.visible = true;
                this.textboxDayOfMonth.visible = false;
                this.textboxTimeOfDay.visible = true;
                break;
            case("M"):
                this.textboxDayOfWeek.visible = false;
                this.textboxDayOfMonth.visible = true;
                this.textboxTimeOfDay.visible = true;
                break;
            case("D"):
                this.textboxDayOfWeek.visible = false;
                this.textboxDayOfMonth.visible = false;
                this.textboxTimeOfDay.visible = true;
                break;
            default:
                this.textboxDayOfWeek.visible = false;
                this.textboxDayOfMonth.visible = false;
                this.textboxTimeOfDay.visible = false;
            }
     }

    private async setLastTimeRun() {
        const input = { process: "OutstandingStatusRpt" };
        const response = await Api.search("lme/datafusion/edi-monitor", input);
        if (response) {  
            const lastAliveDate: Date = new Date(response.data[0].last_alive);
            const lastAliveDateFormatted = DateUtil.formatDateTime(lastAliveDate, DateUtil.getUserDateTimeFormat());
            this.labelLastAlive.text = lastAliveDateFormatted;
        }
    }

    sourceEdiMonitorControlBeforeExecution(event: DataSourceExecutionEvent) {
        const occurrence = this.textboxOccurrence.text;
        const dayRequired = occurrence === "Day";
        const weekRequired = occurrence === "Week";
        const monthRequired = occurrence === "Month";
        
        const arriveInt = parseInt(this.textboxCheckArrivalInt.text);
        const departInt = parseInt(this.textboxCheckDeptInt.text);

        this.textboxDayOfWeek.tooltip = 'Choose day of week to run report';
        this.textboxDayOfMonth.tooltip = 'Choose day of month to run report';
        this.textboxTimeOfDay.tooltip = 'Choose hour in day for report to run';
        this.textboxCheckArrivalInt.tooltip = 'Acceptable interval in minutes';
        this.textboxCheckDeptInt.tooltip = 'Acceptable interval in minutes';

        this.tabLogistics.forEveryChildComponent(comp => {
                    if (comp instanceof Textbox && comp.validationWarning) {
                        comp.validationWarning = null;
                    }
        })

        if(weekRequired || dayRequired || monthRequired){
            this.validateField(this.textboxTimeOfDay, event);
        }

        if (weekRequired) {
            this.validateField(this.textboxDayOfWeek, event);
        }

        if (monthRequired) {
            this.validateField(this.textboxDayOfMonth, event);
        }

        if((arriveInt <= 0 || arriveInt > 3000)){
            event.preventDefault();
            this.textboxCheckArrivalInt.validationWarning = 'The interval for this bracket must be between 1 and 3000.';
        }

        if((departInt <= 0 || departInt > 3000)) {
            event.preventDefault();
            this.textboxCheckDeptInt.validationWarning = 'The interval for this bracket must be between 1 and 3000.';
        }

    }

    validateField(comp: Textbox, event: DataSourceExecutionEvent) {
        if (comp.text === "") {
            event.preventDefault();
            comp.validationWarning = 'Required';
        }
    }


   
}